import { useEffect } from "react";
import type { Story } from "@/mocks/chigua";

interface Props {
  story: Story;
  onClose: () => void;
}

const demoFloors = [
  { no: 1, author: "搬瓜工小乙", time: "第 1 楼 · 开楼", text: "占个楼先把瓜码住，等一个完整版和官方说法。" },
  { no: 9, author: "蹲帖不熬夜", time: "第 9 楼", text: "有消息记得踢我，先在这楼蹲个位。" },
  { no: 14, author: "细节党", time: "第 14 楼", text: "刚翻到一段相关片段，时间线对得上，先标记一下待复盘。" },
  { no: 27, author: "理性吃瓜", time: "第 27 楼", text: "先别急着下结论，蹲官方口径，楼里别互相抬杠。" },
  { no: 33, author: "夜猫子", time: "第 33 楼", text: "楼上整理的那几层很清晰，跟官方时间线基本能对应上，继续跟进。" },
];

export default function ThreadModal({ story, onClose }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-foreground-950/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative flex max-h-[86vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl bg-background-50 shadow-xl">
        <div className="flex items-start justify-between gap-3 border-b border-background-200 px-6 py-5">
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
              <i className="ri-chat-3-line text-xl leading-none" />
            </span>
            <div>
              <p className="text-xs text-foreground-500">{story.cat} · {story.status}</p>
              <h3 className="mt-0.5 text-base font-medium leading-snug text-foreground-900">{story.title}</h3>
              <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-xs text-foreground-500">
                <span>{story.floorCount} 楼</span>
                <span>{story.followers}</span>
                <span>{story.latestTime}</span>
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg text-foreground-600 hover:bg-background-200"
          >
            <i className="ri-close-line leading-none" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          <p className="rounded-xl bg-background-100 px-4 py-3 text-sm leading-relaxed text-foreground-600">
            {story.desc}
          </p>
          <ol className="mt-4 space-y-0">
            {demoFloors.map((f) => (
              <li key={f.no} className="relative flex gap-3 py-3">
                <span className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-100 text-xs font-bold text-accent-800">
                  {f.no}
                </span>
                <div className="min-w-0 flex-1 border-b border-background-100 pb-3">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-sm font-medium text-foreground-900">{f.author}</span>
                    <span className="text-xs text-foreground-400">{f.time}</span>
                  </div>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{f.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="border-t border-background-200 bg-background-100/60 px-6 py-3 text-center text-xs text-foreground-500">
          楼层更新中 · 新进展会第一时间顶上来，请在首页持续吃瓜跟进
        </div>
      </div>
    </div>
  );
}